// Italian translation catalog. Add new languages by creating a sibling file
// and registering it in ./index.js — UI never hardcodes strings.
const it = {
  common: {
    appName: "412Level",
    loading: "Caricamento…",
    save: "Salva",
    cancel: "Annulla",
    delete: "Elimina",
    edit: "Modifica",
    close: "Chiudi",
    confirm: "Conferma",
    back: "Indietro",
    next: "Avanti",
    continue: "Continua",
    upgrade: "Passa a Pro",
    demo: "Demo",
    demoBanner: "Stai visualizzando dati DEMO. Collega il tuo Instagram per vedere i tuoi dati reali.",
    notAvailable: "Dato non disponibile per questo account.",
    followers: "Follower",
    views: "Visualizzazioni",
    likes: "Mi piace",
    comments: "Commenti",
    shares: "Condivisioni",
    saves: "Salvataggi",
    reach: "Reach",
    impressions: "Impression",
    engagement: "Engagement",
    engagementRate: "Tasso di engagement",
    duration: "Durata",
    date: "Data",
    seconds: "secondi",
  },
  nav: {
    dashboard: "Dashboard",
    analytics: "Analytics",
    reels: "I tuoi Reel",
    insights: "Cosa funziona",
    contentAI: "Cosa pubblico?",
    calendar: "Calendario",
    pricing: "Prezzi",
    account: "Account",
    billing: "Abbonamento",
    admin: "Admin",
    logout: "Esci",
    features: "Funzioni",
    faq: "FAQ",
    howItWorks: "Come funziona",
  },
  landing: {
    heroTitle: "Scopri cosa funziona davvero sul tuo Instagram.",
    heroSubtitle: "412Level analizza i tuoi contenuti, individua ciò che fa crescere il tuo profilo e ti suggerisce cosa pubblicare dopo.",
    ctaPrimary: "Analizza gratis il mio Instagram",
    ctaSecondary: "Scopri come funziona",
    trustedBy: "Pensato per creator, influencer e brand che vogliono crescere davvero",
    howTitle: "Come funziona",
    howSubtitle: "Dai dati all'azione in tre semplici passaggi.",
    how1Title: "Collega Instagram",
    how1Desc: "Connetti in modo sicuro il tuo profilo professionale tramite le API ufficiali di Meta. Nessuna password condivisa.",
    how2Title: "Analizziamo tutto",
    how2Desc: "Studiamo crescita, reach, engagement e ogni Reel per capire cosa sta funzionando sul tuo profilo.",
    how3Title: "Ricevi suggerimenti",
    how3Desc: "Ti diciamo cosa pubblicare dopo, con idee e script personalizzati basati sui tuoi dati reali.",
    sectionContentTitle: "Analisi dei contenuti",
    sectionContentDesc: "Ogni Reel viene analizzato: topic, hook, formato, durata e performance relativa al tuo profilo.",
    sectionGrowthTitle: "Crescita follower",
    sectionGrowthDesc: "Monitora la crescita nel tempo con storico completo, anche quando Instagram non lo fornisce.",
    sectionAITitle: "Suggerimenti AI",
    sectionAIDesc: "Intelligenza artificiale che trasforma i tuoi dati in consigli concreti e azionabili.",
    sectionReelTitle: "Idee per nuovi Reel",
    sectionReelDesc: "Ricevi idee personalizzate con titolo, hook, struttura, caption e call to action pronti all'uso.",
    sectionMonitorTitle: "Monitoraggio performance",
    sectionMonitorDesc: "Dashboard chiara con tutte le metriche che contano, in tempo reale.",
    demoTitle: "Guarda 412Level in azione",
    demoDesc: "Una dashboard pensata per farti capire subito come stai crescendo.",
    faqTitle: "Domande frequenti",
    finalCtaTitle: "Pronto a far crescere il tuo Instagram?",
    finalCtaDesc: "Inizia gratis oggi. Nessuna carta di credito richiesta.",
    faq: [
      { q: "412Level usa le API ufficiali di Instagram?", a: "412Level è attualmente in modalità demo: i dati che vedi sono di esempio e chiaramente contrassegnati. L'integrazione con le API ufficiali Meta/Instagram (con autorizzazione OAuth, senza mai chiederti username e password) verrà attivata nella versione live." },
      { q: "Posso provarlo gratis?", a: "Certo. Il piano Free ti permette di collegare un account e vedere le analytics degli ultimi 30 giorni con 3 suggerimenti AI al mese." },
      { q: "Come vengono generati i suggerimenti?", a: "Usiamo i dati disponibili sui tuoi contenuti (topic, formato, durata, orari, views, salvataggi, engagement) per individuare pattern e proporre idee coerenti. Quando i dati non sono sufficienti per un pattern affidabile, lo segnaliamo chiaramente." },
      { q: "I miei dati sono al sicuro?", a: "Sì. Seguiamo le best practice di sicurezza e siamo progettati nel rispetto del GDPR. Puoi esportare o eliminare i tuoi dati in qualsiasi momento." },
      { q: "Posso disdire quando voglio?", a: "Sì, puoi gestire o annullare l'abbonamento in qualsiasi momento dal portale clienti." },
    ],
  },
  auth: {
    loginTitle: "Bentornato",
    loginSubtitle: "Accedi al tuo account 412Level",
    registerTitle: "Crea il tuo account",
    registerSubtitle: "Inizia gratis, nessuna carta richiesta",
    name: "Nome",
    email: "Email",
    password: "Password",
    login: "Accedi",
    register: "Registrati",
    google: "Continua con Google",
    orEmail: "oppure con email",
    noAccount: "Non hai un account?",
    haveAccount: "Hai già un account?",
    forgot: "Password dimenticata?",
    forgotTitle: "Recupera la password",
    forgotSubtitle: "Ti invieremo un link per reimpostare la password",
    sendReset: "Invia link di recupero",
    resetSent: "Se l'email esiste, riceverai le istruzioni per reimpostare la password.",
    backToLogin: "Torna al login",
    resetTitle: "Imposta una nuova password",
    resetSubtitle: "Scegli una password di almeno 8 caratteri",
    newPassword: "Nuova password",
    confirmPassword: "Conferma nuova password",
    passwordMismatch: "Le password non coincidono",
    resetSubmit: "Salva la nuova password",
    resetDone: "Password aggiornata! Ora puoi accedere con la nuova password.",
    resetInvalid: "Questo link non è valido, è scaduto o è già stato utilizzato.",
    requestAgain: "Richiedi un nuovo link",
  },
  onboarding: {
    step: "Passo",
    welcomeTitle: "Benvenuto su 412Level",
    welcomeDesc: "In pochi secondi configuriamo il tuo account per darti i suggerimenti più precisi.",
    typeTitle: "Che tipo di utente sei?",
    nicheTitle: "Qual è la tua nicchia principale?",
    connectTitle: "Collega il tuo Instagram",
    connectDesc: "Ci colleghiamo tramite le API ufficiali di Meta. In questa demo caricheremo un profilo di esempio con dati realistici.",
    connectBtn: "Collega Instagram (Demo)",
    finish: "Vai alla dashboard",
    types: {
      creator: "Creator", influencer: "Influencer", personal_brand: "Personal brand",
      business: "Azienda", smm: "Social media manager", agency: "Agenzia", other: "Altro",
    },
    niches: {
      travel: "Travel", fitness: "Fitness", beauty: "Beauty", fashion: "Fashion",
      food: "Food", business: "Business", finance: "Finance", entertainment: "Entertainment",
      lifestyle: "Lifestyle", gaming: "Gaming", education: "Education", technology: "Technology",
      adult: "Adult creator", other: "Altro",
    },
  },
  dashboard: {
    greeting: "Ciao {name}, ecco come sta andando il tuo Instagram.",
    currentFollowers: "Follower attuali",
    last30: "negli ultimi 30 giorni",
    followerGrowth: "Crescita follower",
    totalViews: "Visualizzazioni Reel",
    avgEngagement: "Engagement medio",
    totalReach: "Reach complessiva",
    bestContent: "Contenuto migliore del periodo",
    growthScore: "Growth Score",
    noAccountTitle: "Nessun Instagram collegato",
    noAccountDesc: "Collega il tuo account per iniziare a vedere i tuoi dati.",
    connect: "Collega Instagram",
    lastUpdate: "Ultimo aggiornamento",
    refresh: "Aggiorna dati",
    connected: "Instagram collegato",
    ranges: { "7": "7 giorni", "30": "30 giorni", "90": "90 giorni", "365": "1 anno", "all": "Tutto" },
    rangeLabels: { "7": "negli ultimi 7 giorni", "30": "negli ultimi 30 giorni", "90": "negli ultimi 90 giorni", "365": "nell'ultimo anno", "all": "nell'intero periodo disponibile" },
  },
  analytics: {
    title: "Analytics",
    subtitle: "Analisi dettagliata delle tue performance",
    followersGained: "Follower acquisiti",
    followersLost: "Follower persi",
    followersNet: "Crescita netta",
    growthPct: "Crescita percentuale",
    avgPerReel: "Performance media per Reel",
    clampedNotice: "Il piano Free mostra solo gli ultimi 30 giorni. Passa a Pro per lo storico completo.",
  },
  reels: {
    title: "I tuoi Reel",
    subtitle: "Tutti i tuoi contenuti con Growth Score",
    sortBy: "Ordina per",
    sort: {
      recent: "Più recenti", views: "Più visualizzati", likes: "Più mi piace",
      comments: "Più commentati", shares: "Più condivisi", engagement: "Engagement più alto",
      score: "Performance score",
    },
    detail: "Dettaglio Reel",
    aiAnalysis: "Analisi AI del contenuto",
    topic: "Topic", format: "Formato", hook: "Hook", cta: "Call to action", performance: "Performance",
    generateScript: "Genera lo script",
  },
  insights: {
    title: "Cosa funziona",
    subtitle: "I pattern che stiamo rilevando nei tuoi contenuti",
    learning: "Stiamo ancora imparando dal tuo account.",
    reelsAnalyzed: "{n} Reel analizzati",
    confidence: "Affidabilità",
    sample: "basato su {n} Reel",
    computedNote: "pattern calcolati dai tuoi dati, non stimati",
  },
  contentAI: {
    title: "Cosa pubblico?",
    subtitle: "Idee personalizzate basate sulle tue performance",
    analyzed: "Abbiamo analizzato i tuoi ultimi {n} Reel.",
    topTopics: "I tuoi topic migliori: {topics}",
    generate: "Genera 8 idee",
    regenerate: "Genera nuove idee",
    ideasTitle: "Ecco le idee che potresti pubblicare",
    structure: "Struttura",
    caption: "Caption suggerita",
    usageLeft: "{n} di {limit} suggerimenti AI rimasti questo mese",
    fairUse: "Suggerimenti AI illimitati (fair-use)",
    emptyIdeas: "Non siamo riusciti a generare idee. Riprova.",
    bestTime: "Orario",
    scenes: "Scene",
    voiceover: "Voiceover",
    scriptTitle: "Genera lo script",
    scriptDuration: "Durata",
    scriptStyle: "Stile",
    scriptGenerate: "Genera lo script",
    scriptResult: "Il tuo script",
    styles: { informativo: "Informativo", storytelling: "Storytelling", ironico: "Ironico", provocatorio: "Provocatorio", educativo: "Educativo", personale: "Personale" },
    notEnough: "Pubblica altri contenuti per ottenere suggerimenti più precisi.",
  },
  calendar: {
    title: "Calendario contenuti",
    subtitle: "Programma le tue idee di contenuto",
    add: "Aggiungi contenuto",
    newItem: "Nuovo contenuto",
    itemTitle: "Titolo",
    notes: "Note",
    week: "Settimana", month: "Mese",
    statuses: { idea: "Idea", da_registrare: "Da registrare", registrato: "Registrato", da_montare: "Da montare", pronto: "Pronto", pubblicato: "Pubblicato" },
  },
  pricing: {
    title: "Piani e prezzi",
    subtitle: "Scegli il piano giusto per la tua crescita",
    perMonth: "/mese",
    mostChosen: "Più scelto",
    currentPlan: "Piano attuale",
    free: { name: "Free", cta: "Inizia gratis", features: ["1 account Instagram", "Analytics base", "Ultimi 30 giorni", "Crescita follower", "Analisi base dei Reel", "Max 3 suggerimenti AI al mese"] },
    pro: { name: "Pro", cta: "Passa a Pro", features: ["1 account Instagram", "Storico completo", "Analytics avanzate", "Growth Score", "Analisi AI avanzata", "Suggerimenti AI illimitati (fair-use)", "Generatore idee", "Generatore script", "Report settimanale", "Calendario contenuti"] },
    agency: { name: "Agency", cta: "Prova Agency", features: ["Fino a 10 account Instagram", "Tutte le funzioni Pro", "Gestione clienti", "Dashboard separate", "Esportazione report", "Membri del team (in arrivo)"] },
  },
  account: {
    title: "Impostazioni account",
    profile: "Profilo",
    security: "Sicurezza",
    dataPrivacy: "Dati e privacy",
    name: "Nome", email: "Email", language: "Lingua", timezone: "Fuso orario",
    currentPassword: "Password attuale", newPassword: "Nuova password",
    changePassword: "Cambia password", updateEmail: "Aggiorna email",
    plan: "Piano corrente", manageSub: "Gestisci abbonamento",
    igConnected: "Account Instagram collegato", disconnect: "Scollega",
    exportData: "Esporta i miei dati", deleteAccount: "Elimina account",
    deleteConfirm: "Sei sicuro? Questa azione è irreversibile e cancellerà tutti i tuoi dati.",
    deleteConfirmCta: "Elimina definitivamente",
    saved: "Modifiche salvate",
  },
  billing: {
    title: "Abbonamento",
    subtitle: "Gestisci il tuo piano e i pagamenti",
    currentPlan: "Piano corrente",
    status: "Stato",
    renewsOn: "Si rinnova il",
    manage: "Gestisci pagamento e fatture",
    canceled: "Il tuo abbonamento verrà annullato al termine del periodo.",
    cancelScheduled: "Cancellazione programmata",
    cancelScheduledFor: "Cancellazione programmata per il",
    activeUntil: "Attivo fino al",
    upgrade: "Aggiorna piano",
  },
  admin: {
    title: "Pannello amministrativo",
    totalUsers: "Utenti totali", newUsers: "Nuovi utenti (7g)", activeUsers: "Utenti attivi",
    freeUsers: "Utenti Free", proUsers: "Utenti Pro", agencyUsers: "Utenti Agency",
    mrr: "MRR", conversion: "Conversion Free→Paid", churn: "Churn",
    igConnected: "Account IG collegati", aiUsage: "Utilizzo AI", apiErrors: "Errori API",
    searchUsers: "Cerca utenti per nome o email", users: "Utenti",
  },
  notifications: { title: "Notifiche", empty: "Nessuna notifica", markRead: "Segna tutte come lette" },
  upgrade: { title: "Funzione Pro", cta: "Passa a Pro", later: "Più tardi" },
  legal: {
    privacy: "Privacy Policy", terms: "Termini e condizioni", cookies: "Cookie Policy",
    cookieConsent: "Utilizziamo cookie tecnici e, previo consenso, cookie di analisi per migliorare l'esperienza.",
    accept: "Accetta", reject: "Rifiuta",
  },
  footer: {
    product: "Prodotto", legal: "Legale", company: "Azienda",
    rights: "Tutti i diritti riservati.",
    supportPending: "Supporto via email: in attivazione",
  },
  errors: {
    generic: "Si è verificato un errore. Riprova più tardi.",
    network: "Impossibile contattare il server.",
  },
};

export default it;
